module.exports = __webpack_public_path__ + "img/466.c8c2b723.jpg";